import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Grid, Icon } from "@mui/material";
import MDTypography from "ui/MDTypography";
import MDButton from "ui/MDButton";
import MDBox from "ui/MDBox";
import MDAlert from "ui/MDAlert";
import { DetailRow } from "layouts/common/detail-page";
import { DetailPageLayout } from "examples/LayoutContainers/DetailPageLayout";
import meetingServices from "services/meeting-services";
import { QRCodeCanvas } from "qrcode.react";

const MeetingDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [meeting, setMeeting] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState(false);

  useEffect(() => {
    const fetchMeeting = async () => {
      try {
        const MeetingData = await meetingServices.get(id);
        if (MeetingData.success && MeetingData.meeting) {
          const formattedMeeting = {
            ...MeetingData.meeting,
            date: MeetingData.meeting.date
              ? new Date(MeetingData.meeting.date).toLocaleDateString("en-CA")
              : "",
          };
          setMeeting(formattedMeeting);
        }
      } catch (err) {
        setNotification({ type: "error", message: "Failed to fetch meeting details." });
      }
      setLoading(false);
    };
    fetchMeeting();
  }, [id]);

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => setNotification(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const handleEditClick = () => {
    if (!meeting?.date) return;

    const meetingDate = new Date(meeting.date);
    const today = new Date();
    meetingDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (meetingDate < today) {
      setNotification({
        type: "warning",
        message: "This meeting cannot be edited because its date has passed.",
      });
    } else {
      navigate(`/meeting/${meeting.id}/edit`);
    }
  };

  const renderMeetingDetails = () => {
    if (!meeting) return <MDTypography variant="body2" color="error">Meeting Not Found</MDTypography>;

    const { title, venue, createdBy, date } = meeting;

    return (
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <DetailRow label="Meeting Title" value={title} />
            </Grid>
            <Grid item xs={3}>
              <DetailRow label="Center/Venue" value={venue} />
            </Grid>
            <Grid item xs={3}>
              <DetailRow label="Date" value={date} />
            </Grid>
            <Grid item xs={3}>
              <DetailRow label="Created By" value={createdBy?.name} />
            </Grid>
          </Grid>
        </Grid>
        {meeting.qrUrl && (
          <Grid item xs={12} textAlign="center" marginTop={3}>
            <MDTypography variant="h6" color="dark">Meeting QR Code</MDTypography>
            <QRCodeCanvas
              value={meeting.qrUrl}
              size={180}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
              includeMargin={true}
              style={{ marginTop: "10px" }}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  const actionButtons = () => (
    <MDButton color="light" onClick={handleEditClick}>
      <Icon sx={{ fontWeight: "bold" }}>edit</Icon>&nbsp;Edit
    </MDButton>
  );

  return (
    <DetailPageLayout
      title={"Meeting Details"}
      renderContent={() => (
        <>
          {notification && (
            <MDBox mb={2}>
              <MDAlert color={notification.type}>
                <MDTypography variant="body2" color="white">
                  {notification.message}
                </MDTypography>
              </MDAlert>
            </MDBox>
          )}
          {renderMeetingDetails()}
        </>
      )}
      actionButtons={actionButtons}
      backButtonRoute={"/meeting"}
      loading={loading}
    />
  );
};

export default MeetingDetail;
